import { useState, useEffect, useCallback, useRef } from "react";

export const useDataFetch = (asyncCallback, deps) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const initialLoading = useRef(true);

  const makeFetch = useCallback(async () => {
    setLoading(true);
    try {
      const result = await asyncCallback();

      setData(result);
    } catch (ex) {
      setData(null);
    }

    initialLoading.current = false;
    setLoading(false);

    // eslint-disable-next-line
  }, deps || [asyncCallback]);

  useEffect(() => {
    makeFetch();
  }, [makeFetch]);

  return [data, loading, initialLoading.current, makeFetch];
};
